export default "__VITE_ASSET__BGbQZMy3__"